import { render, staticRenderFns } from "./review-card.vue?vue&type=template&id=a6b2f45a&scoped=true&"
import script from "./review-card.vue?vue&type=script&lang=js&"
export * from "./review-card.vue?vue&type=script&lang=js&"
import style0 from "./review-card.vue?vue&type=style&index=0&id=a6b2f45a&lang=scss&scoped=true&"
import style1 from "./review-card.vue?vue&type=style&index=1&id=a6b2f45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b2f45a",
  null
  
)

export default component.exports
import {QCard,QCardSection,QAvatar,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QAvatar,QImg})
